import { render, staticRenderFns } from "./SoftwareSupport.vue?vue&type=template&id=5e2ba320&scoped=true"
import script from "./SoftwareSupport.vue?vue&type=script&lang=js"
export * from "./SoftwareSupport.vue?vue&type=script&lang=js"
import style0 from "./SoftwareSupport.vue?vue&type=style&index=0&id=5e2ba320&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ba320",
  null
  
)

export default component.exports